/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function updateVariant(selectElement) {
  const lineId = selectElement.getAttribute('data-line-id'); // Get the line number
  const variantId = selectElement.value; // Get the selected variant ID

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: parseInt(lineId, 10), // Line index of the cart item
      quantity: 0, // Set the current line item to 0 (removes it)
    }),
  })
    .then(() => {
      // Add the new variant to the cart
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10), // New variant ID
          quantity: 1, // Add 1 of the new variant
        }),
      });
    })
    .then((response) => response.json()).then((response)=>{
      const cartItem = selectElement.closest('.cart__item');
      const imageElement = cartItem.querySelector('.cart__item__image img');
      console.log(imageElement);
      console.log(response.image);
      imageElement.src = response.image;
      imageElement.srcset = `${response.image} 90w, ${response.image} 180w, ${response.image} 270w, ${response.image} 360w`;
      
    })
      
  
    .catch((error) => {
      console.error('Error updating the cart:', error);
      alert('Failed to update the variant. Please try again.');
    });
}
(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
